import { UrgencyTextShort } from '@mc/promos'
import classes from './Hero.module.scss'

/**
 * The promo ribbon across the top-right corner of the pricing card.
 *
 * Absolutely positioned: the host card owns the `position: relative` it
 * anchors to and the `overflow: hidden` that clips it to the card's rounded
 * corner.
 *
 * Centers its own copy rather than inheriting the alignment of whatever hosts
 * it. Only the middle of the band is inside the card — both ends are clipped by
 * the corner — so left-aligned copy starts outside the card and loses its first
 * word.
 */
export const DiagonalBanner = () => (
  <div
    className={`mc-bg-light position-absolute mc-text--center d-flex align-items-center justify-content-center ${classes.diagonalBanner}`}
    style={{
      right: -41,
      transform: 'rotate(36deg)',
      width: 180,
      height: 27,
    }}
  >
    <span
      className='mc-text-x-small mc-text--bold mc-text-color--primary mc-text--capitalize mc-pl-md-4 mc-pl-lg-0'
      style={{
        lineHeight: '145%',
      }}
    >
      <UrgencyTextShort />
    </span>
  </div>
)
